import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  reviewModificationsData: [],
  userModificationsData: [],
  questionDetails: {}
};

export const approveReviewModificationsSlice = createSlice({
  name: 'approveReviewModifications',
  initialState,
  reducers: {
    setReviewModificationsData: (state, action) => {
      state.reviewModificationsData = action.payload;
    },
    setReviewModificationsLoader: (state, action) => {
      state.isLoading = action.payload;
    },
    setUserModificationsData: (state, action) => {
      state.userModificationsData = action.payload;
    },
    setQuestionDetails: (state, action) => {
      state.questionDetails = action.payload;
    }
  }
});

export const getReviewModificationsAction = createAction('GET_REVIEW_MODIFICATIONS');
export const getUserModificationsAction = createAction('GET_USER_MODIFICATIONS');
export const getQuestionsPreviewModificationsAction = createAction('GET_QUESTIONS_PREVIEW_APPROVE_MODIFICATIONS');
export const sendSMEEmailAction = createAction('SEND_SME_EMAIL');
export const deleteQuestionAction = createAction('DELETE_QUESTION');

export const { setReviewModificationsData, setReviewModificationsLoader, setUserModificationsData, setQuestionDetails } =
  approveReviewModificationsSlice.actions;

export default approveReviewModificationsSlice.reducer;
